import { defineAsyncComponent } from "vue";

export default [
  {
    name: "StudentGroupResourceAttemptCover",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonViewerCover")),
    path: "",
    props: true,
  },
  {
    name: "StudentGroupResourceAttemptEnd",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonViewerEnd")),
    path: "end",
    props: true,
  },
  {
    name: "StudentGroupResourceAttemptSectionCover",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerSectionCover"),
    ),
    path: "section/:sectionId",
    props: true,
  },
  {
    name: "StudentGroupResourceAttemptSectionEnd",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerSectionEnd"),
    ),
    path: "section/:sectionId/end",
    props: true,
  },
  {
    name: "StudentGroupResourceAttemptActivityPage",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerActivity"),
    ),
    path: "section/:sectionId/activity/:pageId",
    props: true,
  },
  {
    name: "StudentGroupResourceAttemptCommonSpaceView",
    component: defineAsyncComponent(() => import("@modules/attempt/components/CommonSpace")),
    path: "section/:sectionId/activity/:pageId/common-space/:componentId",
    props: true,
  },
  {
    name: "StudentGroupResourceAttemptConversationRoomView",
    component: defineAsyncComponent(
      () => import("@modules/conversation/components/ConversationRoom.vue"),
    ),
    path: "section/:sectionId/activity/:pageId/conversation-room/:resourceUuid",
    props: true,
  },
  {
    name: "StudentGroupResourceAttemptPaused",
    component: defineAsyncComponent(() => import("@modules/attempt/components/AssignmentPaused")),
    path: "paused",
    props: true,
  },
  {
    name: "StudentGroupResourceAttemptPasscode",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonPasscode")),
    path: "passcode",
    props: true,
  },
  {
    path: "not-found",
    name: "StudentGroupResourceAttemptNotFoundPage",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerNotFoundPage"),
    ),
  },
];
